import { createBrowserRouter, Outlet } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { LoginRoutes } from './login';
import { AppRoutes } from './app';

import { AuthLoader } from 'features/auth/components/AuthLoader';
import { ErrorBoundary } from 'components/errorBoundary/ErrorBoundary';

// wrapCreateBrowserRouterV6 may not be in TypeScript types but exists at runtime in Sentry v10
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

// Wrapper for public routes that only need error boundary (no auth)
const PublicLayout = () => (
  <ErrorBoundary>
    <Outlet />
  </ErrorBoundary>
);

const AuthenticatedLayout = () => (
  <ErrorBoundary>
    <AuthLoader>
      <Outlet />
    </AuthLoader>
  </ErrorBoundary>
);

export const router = sentryCreateBrowserRouter([
  // Public routes (login, signup, etc.)
  {
    element: <PublicLayout />,
    children: [...LoginRoutes],
  },
  // Protected routes - wrapped by AuthLoader
  {
    element: <AuthenticatedLayout />,
    children: [...AppRoutes, { path: '*', element: <div>Not found</div> }],
  },
]);
